import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { forgotConfirmation } from '../../containers/Auth/actions';
import ErrorComponent from '../../components/Error';
// images
import imgHeaderBg from '../../img/404-bg.png';
// translate
import messages from './messages';

class ForgotConfirmationPage extends Component {
  componentWillMount() {
    this.checkCode();
  }

  checkCode() {
    const code = this.props.params.code;
    this.props.dispatch(forgotConfirmation(code));
  }

  render() {
    const {
      intl,
      isFetching,
      forgotConfirmationSuccess,
      forgotConfirmationErrorMessage,
    } = this.props;

    return (
      <div>
        <div
          className="error-404-wrap container-fluid"
          style={{ backgroundImage: `url('${imgHeaderBg}')` }}
        >
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <div className="error-404-text">
                    {isFetching &&
                      <FormattedHTMLMessage {...messages.processText} />}
                    {forgotConfirmationSuccess &&
                      <FormattedHTMLMessage {...messages.successText} />}
                    {forgotConfirmationErrorMessage &&
                      !isFetching &&
                      <ErrorComponent>
                        {forgotConfirmationErrorMessage}
                      </ErrorComponent>}
                    <br />
                    {forgotConfirmationSuccess &&
                      <Link to="/#login">
                        {intl.formatMessage(messages.login)}
                      </Link>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotConfirmationPage.defaultProps = {
  forgotConfirmationErrorMessage: false,
};

ForgotConfirmationPage.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  forgotConfirmationErrorMessage: PropTypes.any,
  forgotConfirmationSuccess: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    forgotConfirmationErrorMessage: state.get('auth')
      .forgotConfirmationErrorMessage,
    forgotConfirmationSuccess: state.get('auth').forgotConfirmationSuccess,
    isFetching: state.get('auth').isFetching,
  };
}

export default connect(mapStateToProps)(injectIntl(ForgotConfirmationPage));



// WEBPACK FOOTER //
// ./src/pages/ForgotConfirmationPage/index.js